// Initiate asynchronous procedure of loading user data to cache.
export const CACHE_USER_DATA_START = '@@b2b_portal_ui/auth/cache/CACHE_USER_DATA_START';
export const CACHE_USER_DATA_START_SUCCESSFUL = '@@b2b_portal_ui/auth/cache/CACHE_USER_DATA_START_SUCCESSFUL';
export const CACHE_USER_DATA_START_FAILURE = '@@b2b_portal_ui/auth/cache/CACHE_USER_DATA_START_FAILURE';

// Check is current user data already loaded into cache
export const CHECK_USER_DATA_CACHE = '@@b2b_portal_ui/auth/cache/CHECK_USER_DATA_CACHE';
